import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Fetch initial prescription queues
export const fetchQueues = createAsyncThunk(
  'prescriptionQueue/fetchQueues',
  async (_, { rejectWithValue }) => {
    try {
      const res = await fetch('/api/v1/prescription_queues');
      if (!res.ok) throw new Error('Network response was not ok');
      const data = await res.json();
      return data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

// Patch queue status
export const updateQueueStatus = createAsyncThunk(
  'prescriptionQueue/updateQueueStatus',
  async ({ id, status,prescription_queue_items_attributes  }, { rejectWithValue }) => {
    try {
     // console.log("🧾 Sending PATCH for queue:", { id, status,prescription_queue_items_attributes  });
      const res = await fetch(`/api/v1/prescription_queues/${id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        },
        body: JSON.stringify({ prescription_queue: { status ,prescription_queue_items_attributes  } }),
      });
      const data = await res.json();
      // console.log("📬 Server response status:", res.status);
       if (!res.ok) {
        // Rails error is in data.error
        return rejectWithValue(data);
      }

      // console.log("✅ Queue status updated successfully:", data);
       return data
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const prescriptionQueueSlice = createSlice({
  name: 'prescriptionQueue',
  initialState: {
    queues: [],
    loading: false,
    error: null,
    errorQueueId: null,
    errorItems: {}, 
  },
  reducers: {
    addOrUpdateQueue(state, action) {
      const updatedQueue = action.payload;
      const index = state.queues.findIndex((q) => q.id === updatedQueue.id);
      if (index >= 0) {
        // update existing
        state.queues[index] = updatedQueue;
      } else {
        // add new
        state.queues.unshift(updatedQueue);
      }
    },
    removeQueue(state, action) {
      state.queues = state.queues.filter((q) => q.id !== action.payload);
    },
    subscribeQueues(state, action) {
      const { queue } = action.payload;

      if (queue.status !== 'pending') {
        state.queues = state.queues.filter((q) => q.id !== queue.id);
        return;
      }

      const index = state.queues.findIndex((q) => q.id === queue.id);

      if (index >= 0) {
        state.queues[index] = {
          ...state.queues[index],
          ...queue
        };
      } else {
        state.queues.unshift(queue);
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchQueues.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchQueues.fulfilled, (state, action) => {
        state.loading = false;
        state.queues = action.payload;
      })
      .addCase(fetchQueues.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateQueueStatus.fulfilled, (state, action) => {
        const updatedQueue = action.payload;

        // Remove from queue if status is dispensed or cancelled
        if (updatedQueue.status === 'dispensed' || updatedQueue.status === 'cancelled') {
          state.queues = state.queues.filter((q) => q.id !== updatedQueue.id);
        } else {
          // Otherwise, update the existing queue
          const index = state.queues.findIndex((q) => q.id === updatedQueue.id);
          if (index >= 0) state.queues[index] = updatedQueue;
        }

          // Clear errors for this queue
        if (state.errorQueueId === updatedQueue.id) {
          state.errorQueueId = null;
          state.error = null;
          state.errorItems[updatedQueue.id] = [];
        }
      })
      .addCase(updateQueueStatus.rejected, (state, action) => {
        state.error = action.payload;
        state.errorQueueId = action.meta.arg.id; 
        state.errorItems = {};

        if (action.payload?.items && action.meta.arg?.id) {
            state.errorItems[action.meta.arg.id] = action.payload.items;
        }
    
      });
  },
});

export const { addOrUpdateQueue, removeQueue, subscribeQueues } = prescriptionQueueSlice.actions;
export default prescriptionQueueSlice.reducer;
